import merge from 'lodash.merge';
import { createContext, useContext, useState } from 'react';

type PreviewControlProviderProps = {
  enableChartAnimation?: boolean;
  children: React.ReactNode;
};

const defaultConfig = { chart: { animation: false, duration: 0 } };

const PreviewControlContext = createContext(defaultConfig);

export const usePreviewControl = () => {
  return useContext(PreviewControlContext);
};

export const PreviewControlProvider = ({ enableChartAnimation, children }: PreviewControlProviderProps) => {
  const [config] = useState(merge({ ...defaultConfig }, { chart: { animation: !!enableChartAnimation } }));
  return <PreviewControlContext.Provider value={config}>{children}</PreviewControlContext.Provider>;
};
